// Webpack-alias target for the exact "date-fns/locale" specifier (see
// craco.config.js). The real index re-exports every locale date-fns ships
// (~90 locales, ~819 kB raw in the main bundle); the only importer of the
// full index is @smartsuite/fields-logic's languageToFnsLocale map
// (lib/utils/date.js), which references exactly the locales below.
// App code imports individual locales by subpath ("date-fns/locale/en-US"),
// which the trailing-$ alias deliberately leaves untouched.
//
// Tripwire: src/utils/__tests__/dateFnsLocaleShim.test.ts compares this list
// against the installed fields-logic sources and fails when an upgrade starts
// referencing a locale that is missing here. A missing locale degrades, not
// crashes: date-fns format() receives `undefined` and falls back to en-US
// wording.
//
// The "/index.js" suffix is load-bearing. Each locale directory ships both a
// CJS build ("main") and an ESM one ("module"); webpack prefers "module", and
// a CommonJS require() of an ES module yields the namespace ({ default: Locale
// }), which has no `localize` — date-fns format() then throws "RangeError:
// locale must contain localize property". Pointing at the file skips the
// package.json fields, so the bundler and Jest load the same CJS build.
module.exports = {
  bg: require("date-fns/locale/bg/index.js"),
  cs: require("date-fns/locale/cs/index.js"),
  de: require("date-fns/locale/de/index.js"),
  enUS: require("date-fns/locale/en-US/index.js"),
  es: require("date-fns/locale/es/index.js"),
  fr: require("date-fns/locale/fr/index.js"),
  hi: require("date-fns/locale/hi/index.js"),
  it: require("date-fns/locale/it/index.js"),
  ja: require("date-fns/locale/ja/index.js"),
  nl: require("date-fns/locale/nl/index.js"),
  pl: require("date-fns/locale/pl/index.js"),
  ptBR: require("date-fns/locale/pt-BR/index.js"),
  ro: require("date-fns/locale/ro/index.js"),
  ru: require("date-fns/locale/ru/index.js"),
  sv: require("date-fns/locale/sv/index.js"),
  uk: require("date-fns/locale/uk/index.js"),
  zhCN: require("date-fns/locale/zh-CN/index.js"),
};
